import { render, staticRenderFns } from "./OrganizationEditView.vue?vue&type=template&id=2c9098ce&"
import script from "./OrganizationEditView.vue?vue&type=script&lang=ts&"
export * from "./OrganizationEditView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports